export const TRANSLATIONS = {
  de: {
    brandTitle: "GAIAMUNDI",

    hero: "Gaiamundi ist aus Farbe entstanden. Aus Erde unter den Füßen. Aus Sonne auf der Haut. Und aus dem unbändigen Drang, die Welt ein kleines bisschen leuchtender zu machen.",

    enterGallery: "Werke entdecken",
    manifestLink: "Unsere Vision",

    manifestMeta: "Unsere Vision",
    manifestTitle: "Kunst, die verbindet.",
    manifestText: "Wir sind Mel & Lena. Gaiamundi ist aus Begegnungen entstanden – aus unserem Leben in Samaipata, aus Natur, Gesprächen und gemeinsamem Tun. Wir glauben an Kunst auf Augenhöhe: ehrlich, handgemacht, lebendig. Unsere Werke entstehen langsam, mit Zeit, Aufmerksamkeit und Respekt – nicht KI-generiert, sondern menschlich. Uns interessiert Verbindung, nicht Perfektion.",

    closingTitle: "Lasst uns begegnen.",
    closingText: "www.gaiamundi.com · Tel +591 633 787 33 · gaiamundi.illustration@gmail.com",

    ambient: "Ambient",
    ambientActive: "Ambient ●",

    galleryMeta: "Galerie",
    galleryHeading: "Ausgewählte Werke",
    galleryDesc: "Klicke auf ein Werk für die Vollansicht. Für Ausstellungen, Prints oder Kooperationen freuen wir uns über deine Nachricht.",

    room1Meta: "Lena",
    room1Title: "Farbe als Sprache",
    room1Text: "Lena ist Künstlerin & Illustratorin. Sie malt nicht einfach Bilder – sie malt Stimmungen. Naturträume. Farbstürme. Ihre Werke tragen Verspieltheit und Lebendigkeit in sich. Welten, in die man eintaucht. Räume, in denen man sich erinnert, wie bunt das Leben sein kann.",

    room2Meta: "Mel",
    room2Title: "Weite & Wasser",
    room2Text: "Mel arbeitet in großen Formaten. Wasser ist ihr Element. Landschaften mit Meer, Himmel und weitem Atem prägen ihre Arbeit. Ihre Kunst trägt Ruhe, Tiefe und Balance – kraftvoll und elegant zugleich, wie eine Welle, die weiß, wann sie trägt und wann sie sich zurückzieht.",

    room3Meta: "Gemeinsamer Raum",
    room3Title: "Offen für Begegnung",
    room3Text: "Gaiamundi ist ein offener Raum für kreative Entwicklung, Austausch und das, was zwischen Menschen wächst, wenn man sich wirklich begegnet. Manchmal tanzt man mit einem Schmetterling. Manchmal kartografiert man Wolken. Genau dort entstehen die besten Ideen."
  },

  en: {
    brandTitle: "GAIAMUNDI",

    hero: "Gaiamundi was born from color. From earth beneath bare feet. From sun on warm skin. And from the deep urge to make the world a little more luminous.",

    enterGallery: "Discover the Works",
    manifestLink: "Our Vision",

    manifestMeta: "Our Vision",
    manifestTitle: "Art that connects.",
    manifestText: "We are Mel & Lena. Gaiamundi grew out of encounters – from our life in Samaipata, from nature, conversations and shared creation. We believe in art at eye level: honest, handmade and alive. Our works are created slowly, with time, attention and respect – not AI-generated, but human. We care about connection, not perfection.",

    closingTitle: "Let’s connect.",
    closingText: "www.gaiamundi.com · Tel +591 633 787 33 · gaiamundi.illustration@gmail.com",

    ambient: "Ambient",
    ambientActive: "Ambient ●",

    galleryMeta: "Gallery",
    galleryHeading: "Selected Works",
    galleryDesc: "Click a piece to view it in fullscreen. For exhibitions, prints or collaborations, feel free to reach out.",

    room1Meta: "Lena",
    room1Title: "Color as Language",
    room1Text: "Lena is an artist & illustrator. She does not simply paint images – she paints moods. Nature dreams. Storms of color. Her works carry playfulness and vitality. Worlds you can step into. Spaces that remind you how vibrant life truly is.",

    room2Meta: "Mel",
    room2Title: "Water & Vastness",
    room2Text: "Mel works on large-scale formats. Water is her element. Seascapes, open skies and wide horizons shape her art. Her paintings carry calmness, depth and balance – powerful and elegant at once, like a wave that knows when to carry and when to retreat.",

    room3Meta: "Shared Space",
    room3Title: "Open for Encounter",
    room3Text: "Gaiamundi is an open space for creative growth, exchange and what emerges when people truly meet. Sometimes you dance with a butterfly. Sometimes you map the clouds. That is where the best ideas are born."
  },

  es: {
    brandTitle: "GAIAMUNDI",

    hero: "Gaiamundi nació del color. De la tierra bajo los pies. Del sol sobre la piel. Y del impulso profundo de hacer el mundo un poco más luminoso.",

    enterGallery: "Descubrir las Obras",
    manifestLink: "Nuestra Visión",

    manifestMeta: "Nuestra Visión",
    manifestTitle: "Arte que conecta.",
    manifestText: "Somos Mel & Lena. Gaiamundi nació de los encuentros – de nuestra vida en Samaipata, de la naturaleza, las conversaciones y la creación compartida. Creemos en un arte honesto, hecho a mano y vivo. Nuestras obras nacen lentamente, con tiempo, atención y respeto – no generadas por IA, sino humanas. Nos interesa la conexión, no la perfección.",

    closingTitle: "Conectemos.",
    closingText: "www.gaiamundi.com · Tel +591 633 787 33 · gaiamundi.illustration@gmail.com",

    ambient: "Ambient",
    ambientActive: "Ambient ●",

    galleryMeta: "Galería",
    galleryHeading: "Obras Seleccionadas",
    galleryDesc: "Haz clic en una obra para verla en pantalla completa. Para exposiciones, impresiones o colaboraciones, escríbenos.",

    room1Meta: "Lena",
    room1Title: "El Color como Lenguaje",
    room1Text: "Lena es artista e ilustradora. No pinta simplemente imágenes – pinta emociones. Sueños naturales. Tormentas de color. Sus obras transmiten juego y vitalidad. Mundos en los que uno puede sumergirse y recordar lo vibrante que puede ser la vida.",

    room2Meta: "Mel",
    room2Title: "Agua y Amplitud",
    room2Text: "Mel trabaja en grandes formatos. El agua es su elemento. Paisajes marinos, cielos abiertos y horizontes amplios definen su arte. Sus pinturas transmiten calma, profundidad y equilibrio – poderosas y elegantes a la vez, como una ola que sabe cuándo sostener y cuándo retirarse.",

    room3Meta: "Espacio Compartido",
    room3Title: "Abierto al Encuentro",
    room3Text: "Gaiamundi es un espacio abierto para el crecimiento creativo, el intercambio y lo que surge cuando las personas se encuentran de verdad. A veces bailas con una mariposa. A veces cartografías las nubes. Allí nacen las mejores ideas."
  }
};

export const LANGUAGES = ['de', 'en', 'es'];
export const DEFAULT_LANG = 'de';
